import React from 'react'

import { MenuContext } from 'context/menu/MenuContext'

// styles
import { menuButtonContainer, menuBar, menuBarAnimated } from './styles'
import { conditionalClass } from '@/shared/utils'

interface Props {
  size?: number
}

const BARS = 3

export const MenuButton: React.FC<Props> = ({ size = 24 }) => {
  const { isOpen, toggleMenu } = React.useContext(MenuContext)

  return (
    <div
      style={{ width: size, height: size }}
      className={menuButtonContainer}
      onClick={toggleMenu}
    >
      {Array.from(Array(BARS).keys()).map((_, index) => (
        <div
          key={index}
          className={conditionalClass(isOpen, menuBarAnimated, menuBar)}
        ></div>
      ))}
    </div>
  )
}
